export const apiV1 = url => `/api/v1${url}`;
export const apiV2 = url => `/api.v2${url}`;
export const rpc = url => `/rpc${url}`;
export const gateways = url => `/gateways${url}`;
export const generic = url => `/generic/api${url}`;
export const aiInterviewV1 = url => `/interview-ai/api/v1${url}`;
